export const isValidDateUtil = function (dateString) {
    return (typeof dateString === "object" || isNaN(Number(dateString))) && !isNaN(Date.parse(dateString));
}
